<template>
  <main class="olimpiadas-profile">
    <section class="olimpiadas-profile__card">
      <h2>Completa tu perfil para inscribirte</h2>
      <p>
        Necesitamos tu fecha de nacimiento, país, departamento/estado/provincia
        y género para continuar con tu inscripción.
      </p>
      <UserSettingsForm
        :userData2="userData"
        :reload-on-success="false"
        @saved="handleProfileSaved"
      />
    </section>

    <OlimpiadasRegistrationModal
      :open="showModal"
      @close="handleModalClose"
    />
  </main>
</template>

<script>
import UserSettingsForm from "@/views/V2/settings/components/UserSettingsForm.vue";
import OlimpiadasRegistrationModal from "./OlimpiadasRegistrationModal.vue";
import { getContestBySlug } from "./contestData";
import {
  loadRegistrationIntent,
  runRegistrationFlow,
} from "./registrationFlow";
import { getUserData } from "@/services/auth.service.js";

export default {
  name: "OlimpiadasProfile",
  components: {
    UserSettingsForm,
    OlimpiadasRegistrationModal,
  },
  data() {
    return {
      userData: null,
      showModal: false,
      contest: null,
    };
  },
  async mounted() {
    const token = window.localStorage.getItem("token");
    if (!token) {
      this.$router.push({
        path: "/v2/auth/login",
        query: { redirect: "/olimpiadas/profile" },
      });
      return;
    }

    // Prefer Vuex store (same source as login), then localStorage, then fetch
    const storeData = this.$store.state.auth?.data;
    const authRaw = window.localStorage.getItem("auth");
    const localData = authRaw ? JSON.parse(authRaw).data : null;

    if (storeData && (storeData.name || storeData.email)) {
      this.userData = storeData;
    } else if (localData && (localData.name || localData.email)) {
      this.userData = localData;
    } else {
      try {
        const response = await getUserData(token);
        if (response?.data) {
          this.userData = { ...response.data, token };
          this.$store.dispatch("auth/setLogin", { ...response.data, token });
        }
      } catch (e) {
        console.error("OlimpiadasProfile: could not load user", e);
      }
    }

    if (!this.userData || (!this.userData.name && !this.userData.email)) {
      this.$router.push({
        path: "/v2/auth/login",
        query: { redirect: "/olimpiadas/profile" },
      });
      return;
    }

    const intent = loadRegistrationIntent();
    if (intent && intent.slug) {
      this.contest = getContestBySlug(intent.slug);
    }
  },
  methods: {
    handleProfileSaved() {
      if (!this.contest) return;
      runRegistrationFlow({
        contest: this.contest,
        router: this.$router,
        onNeedsProfile: () => {},
        onRegistered: () => {
          this.showModal = true;
        },
        onError: () => {
          this.$toasted.error("No pudimos completar la inscripción.", {
            position: "top-center",
            duration: 3000,
          });
        },
      });
    },
    handleModalClose() {
      this.showModal = false;
      if (this.contest) {
        this.$router.push(`/course/${this.contest.courseId}/introduction`);
      } else {
        this.$router.push("/dashboard");
      }
    },
  },
};
</script>

<style scoped>
.olimpiadas-profile {
  min-height: 100vh;
  background: #f6f7fb;
  padding: 48px 20px;
  display: grid;
  place-items: center;
}

.olimpiadas-profile__card {
  width: min(840px, 96vw);
  background: #ffffff;
  border-radius: 18px;
  padding: 28px;
  box-shadow: 0 20px 40px rgba(23, 30, 52, 0.08);
}

.olimpiadas-profile__card h2 {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #121826;
}

.olimpiadas-profile__card p {
  color: #5b6476;
  margin-bottom: 20px;
}
</style>
